// Limits mirror the organization-service user table
export const USER_NAME_MAX_LENGTH = 200;
export const USER_EMAIL_MAX_LENGTH = 250;

// Partner and Romulus users have no organization country to default to, unlike in the dashboard
export const USER_PHONE_DEFAULT_COUNTRY = 'IT';
